var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLoginBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 920,
    viewBox: "0 0 800 920",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3899:4024)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 460,
    width: 800,
    height: 512,
    fill: "#151B34"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -52,
    width: 800,
    height: 512,
    fill: "#0000DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.436 619.423H400.229L400.153 619.5C374.387 619.437 349.016 613.175 326.198 601.246C303.318 589.285 283.685 571.981 268.974 550.814C254.264 529.646 244.915 505.245 241.725 479.694C238.535 454.142 241.599 428.201 250.656 404.087C259.713 379.973 274.493 358.402 293.734 341.218C312.975 324.034 336.104 311.747 361.145 305.409C386.187 299.07 412.396 298.867 437.533 304.818C462.495 310.728 485.663 322.531 505.086 339.229L471.096 373.105C452.251 357.846 428.947 349.083 404.677 348.138C380.257 347.187 356.192 354.202 336.135 368.12C316.078 382.037 301.125 402.096 293.545 425.252C285.966 448.408 286.174 473.397 294.138 496.424C302.102 519.452 317.388 539.261 337.674 552.844C357.959 566.427 382.138 573.044 406.539 571.689C430.94 570.334 454.232 561.082 472.878 545.336C491.524 529.591 504.507 508.213 509.855 484.446L509.992 483.836H509.367H498.902H498.511L498.417 484.215C493.88 502.424 484.326 519.007 470.833 532.092C457.34 545.176 440.446 554.242 422.057 558.265C403.668 562.288 384.516 561.108 366.765 554.859C349.154 548.66 333.617 537.716 321.876 523.249L357.064 488.18C361.872 495.523 368.481 501.525 376.269 505.615C384.241 509.801 393.172 511.84 402.178 511.528C411.183 511.216 419.951 508.566 427.613 503.838C435.274 499.111 441.564 492.471 445.859 484.575L446.26 483.836H445.419H361.48L409.219 436.183H558.739C559.907 444.036 560.496 451.965 560.5 459.904C560.5 502.211 543.637 542.785 513.619 572.7C483.601 602.616 442.888 619.423 400.436 619.423ZM463.191 381.059L427.927 416.204C419.704 411.021 410.171 408.269 400.436 408.273H400.359C391.374 408.265 382.542 410.588 374.73 415.012C366.918 419.436 360.396 425.81 355.804 433.508C351.211 441.205 348.708 449.961 348.539 458.915C348.375 467.589 350.408 476.159 354.444 483.836H302.284C297.268 463.501 298.742 442.108 306.506 422.642C314.319 403.056 328.106 386.408 345.922 375.049C363.738 363.69 384.684 358.193 405.803 359.334C426.736 360.465 446.791 368.06 463.191 381.059Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3899:4024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.821 -321.999L349.238 -315.416L755.265 90.6118L761.849 84.0286L355.821 -321.999Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.675 -313.853L341.311 -307.489L747.338 98.5388L753.702 92.1748L347.675 -313.853Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.521 -305.699L333.377 -299.555L739.404 106.473L745.549 100.328L339.521 -305.699Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.375 -297.553L325.443 -291.621L731.471 114.407L737.403 108.475L331.375 -297.553Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.222 -289.4L317.509 -283.686L723.537 122.342L729.25 116.628L323.222 -289.4Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.076 -281.254L309.582 -275.759L715.61 130.268L721.104 124.774L315.076 -281.254Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.93 -273.093L301.655 -267.818L707.683 138.21L712.958 132.935L306.93 -273.093Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.774 -264.947L293.711 -259.884L699.739 146.144L704.802 141.081L298.774 -264.947Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.621 -256.793L285.777 -251.949L691.805 154.078L696.649 149.235L290.621 -256.793Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.475 -248.647L277.85 -244.022L683.878 162.006L688.503 157.381L282.475 -248.647Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.329 -240.5L269.917 -236.088L675.944 169.94L680.357 165.527L274.329 -240.5Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.176 -232.347L261.983 -228.154L668.01 177.874L672.203 173.681L266.176 -232.347Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.023 -224.204L254.049 -220.23L660.076 185.798L664.05 181.824L258.023 -224.204Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.876 -216.057L246.122 -212.302L652.149 193.725L655.904 189.971L249.876 -216.057Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.73 -207.911L238.188 -204.368L644.216 201.659L647.758 198.117L241.73 -207.911Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.584 -199.75L230.261 -196.427L636.289 209.601L639.612 206.277L233.584 -199.75Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.428 -191.604L222.324 -188.5L628.352 217.528L631.456 214.424L225.428 -191.604Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.275 -183.451L214.39 -180.566L620.418 225.462L623.303 222.577L217.275 -183.451Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.129 -175.304L206.456 -172.632L612.484 233.396L615.157 230.723L209.129 -175.304Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.976 -167.151L198.522 -164.697L604.55 241.331L607.004 238.877L200.976 -167.151Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.83 -159.005L190.595 -156.77L596.623 249.257L598.858 247.023L192.83 -159.005Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.677 -150.851L182.661 -148.836L588.689 257.192L590.705 255.177L184.677 -150.851Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.531 -142.705L174.728 -140.902L580.755 265.126L582.558 263.323L176.531 -142.705Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.378 -134.551L166.794 -132.968L572.821 273.06L574.405 271.476L168.378 -134.551Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.238 -126.398L158.874 -125.033L564.902 280.995L566.266 279.63L160.238 -126.398Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.083 -118.252L150.93 -117.099L556.958 288.929L558.11 287.776L152.083 -118.252Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.929 -110.108L142.996 -109.175L549.024 296.853L549.957 295.92L143.929 -110.108Z",
    fill: "#F76A67"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M430.028 1241.85L436.611 1235.27L30.5832 829.241L24 835.824L430.028 1241.85Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.174 1233.71L444.538 1227.34L38.5101 821.314L32.1461 827.678L438.174 1233.71Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.327 1225.55L452.472 1219.41L46.4441 813.38L40.2993 819.525L446.327 1225.55Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.473 1217.41L460.406 1211.47L54.3779 805.445L48.4453 811.378L454.473 1217.41Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.626 1209.25L468.34 1203.54L62.3118 797.511L56.5984 803.225L462.626 1209.25Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.772 1201.11L476.266 1195.61L70.2388 789.584L64.7445 795.078L470.772 1201.11Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.918 1192.95L484.193 1187.67L78.1656 781.643L72.8906 786.918L478.918 1192.95Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.074 1184.8L492.137 1179.74L86.1096 773.709L81.0467 778.771L487.074 1184.8Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.228 1176.65L500.071 1171.8L94.0436 765.774L89.1999 770.618L495.228 1176.65Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.374 1168.5L507.998 1163.88L101.97 757.847L97.3458 762.472L503.374 1168.5Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.52 1160.35L515.932 1155.94L109.904 749.913L105.492 754.325L511.52 1160.35Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.673 1152.2L523.866 1148.01L117.838 741.979L113.645 746.172L519.673 1152.2Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.826 1144.06L531.8 1140.08L125.772 734.055L121.798 738.029L527.826 1144.06Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.972 1135.91L539.727 1132.16L133.699 726.127L129.944 729.882L535.972 1135.91Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.118 1127.76L547.661 1124.22L141.633 718.193L138.09 721.736L544.118 1127.76Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.264 1119.6L555.588 1116.28L149.56 710.252L146.236 713.575L552.264 1119.6Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.42 1111.46L563.524 1108.35L157.497 702.325L154.392 705.429L560.42 1111.46Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.573 1103.3L571.458 1100.42L165.431 694.391L162.546 697.276L568.573 1103.3Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.719 1095.16L579.392 1092.48L173.365 686.457L170.692 689.129L576.719 1095.16Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.873 1087L587.326 1084.55L181.298 678.522L178.845 680.976L584.873 1087Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.019 1078.86L595.253 1076.62L189.225 670.595L186.991 672.83L593.019 1078.86Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.172 1070.7L603.187 1068.69L197.159 662.661L195.144 664.676L601.172 1070.7Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.318 1062.56L611.121 1060.75L205.093 654.727L203.29 656.53L609.318 1062.56Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.471 1054.4L619.055 1052.82L213.027 646.793L211.443 648.376L617.471 1054.4Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.61 1046.25L626.975 1044.89L220.947 638.858L219.582 640.223L625.61 1046.25Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.766 1038.1L634.919 1036.95L228.891 630.924L227.738 632.076L633.766 1038.1Z",
    fill: "#F76A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.919 1029.96L642.853 1029.03L236.825 623L235.891 623.933L641.919 1029.96Z",
    fill: "#F76A67"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3899:4024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 1024,
    fill: "white",
    transform: "translate(0 -52)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3899:4024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 618.85,
    height: 618.85,
    fill: "white",
    transform: "translate(143 -322)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLoginBig);
export default __webpack_public_path__ + "static/media/logo-login-big.ea74c1094ca4c2f939236d05418c6549.svg";
export { ForwardRef as ReactComponent };